import { useState } from 'react'
import { Collapse, Button, ListGroup, Badge } from 'react-bootstrap'

function SitemapCollapse({ sitemapEntries, hasSitemap }) {
  const [open, setOpen] = useState(false)

  if (!hasSitemap || !sitemapEntries || sitemapEntries.length === 0) {
    return null
  }

  return (
    <div className="sitemap-collapse mt-2">
      <Button
        variant="outline-secondary"
        size="sm"
        onClick={() => setOpen(!open)}
        aria-controls="sitemap-content"
        aria-expanded={open}
        className="d-flex align-items-center gap-1"
      >
        <span className="sitemap-icon">
          {open ? '\u25BC' : '\u25B6'}
        </span>
        <span>Sitemap</span>
        <Badge bg="secondary" pill>
          {sitemapEntries.length}
        </Badge>
      </Button>

      <Collapse in={open}>
        <div id="sitemap-content" className="mt-2">
          <ListGroup variant="flush" className="sitemap-list">
            {sitemapEntries.map((entry, index) => (
              <ListGroup.Item
                key={index}
                className="sitemap-entry py-2 px-0"
              >
                <a
                  href={entry.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="sitemap-link text-decoration-none"
                >
                  <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start gap-1">
                    <div className="sitemap-entry-content flex-grow-1 min-width-0">
                      <div className="sitemap-title fw-medium">
                        {entry.title || extractTitleFromUrl(entry.url)}
                      </div>
                      <small className="text-muted sitemap-url text-truncate d-block">
                        {entry.url}
                      </small>
                    </div>
                    <div className="sitemap-meta text-start text-sm-end flex-shrink-0">
                      {entry.priority && (
                        <Badge bg="info" className="me-1">
                          {Math.round(entry.priority * 100)}%
                        </Badge>
                      )}
                      {entry.lastmod && (
                        <small className="text-muted d-block">
                          {formatDate(entry.lastmod)}
                        </small>
                      )}
                    </div>
                  </div>
                </a>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </div>
      </Collapse>
    </div>
  )
}

function extractTitleFromUrl(url) {
  try {
    const urlObj = new URL(url)
    const path = urlObj.pathname.replace(/\/$/, '')
    if (!path || path === '') {
      return urlObj.hostname
    }
    const segments = path.split('/').filter(Boolean)
    if (segments.length === 0) {
      return urlObj.hostname
    }
    const lastSegment = segments[segments.length - 1]
    // Remove file extensions and clean up
    return lastSegment
      .replace(/\.(html?|php|aspx?|jsp)$/i, '')
      .replace(/[-_]/g, ' ')
      .replace(/\b\w/g, c => c.toUpperCase())
  } catch {
    return 'Link'
  }
}

function formatDate(dateStr) {
  try {
    const date = new Date(dateStr)
    if (isNaN(date.getTime())) {
      return dateStr
    }
    return date.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    })
  } catch {
    return dateStr
  }
}

export default SitemapCollapse
